<style scoped lang="scss" type="text/scss">
    .search-box-container {
        .search-input {
            margin-bottom: 1rem;
        }
    }
</style>

<template>
    <div class="search-box-container">
        <el-input class="search-input" v-model="keyword" @keypress.native.enter="search"
                  placeholder="请输入校名，按回车搜索"></el-input>

        <div class="global-relative">
            <loading-placeholder :loading="requesting"></loading-placeholder>

            <el-table :data="candidates" stripe border size="small" style="width: 100%">
                <el-table-column type="index" label="序号" align="center" width="100"></el-table-column>
                <el-table-column prop="competition_name" label="赛事名称" align="center" min-width="180"></el-table-column>
                <el-table-column prop="school_name" label="学校名称" align="center" min-width="120"></el-table-column>
                <el-table-column prop="team_name" label="队伍名称" align="center" min-width="120"></el-table-column>
                <el-table-column prop="registration_deadline_text" label="报名截止时间" align="center"
                                 width="140"></el-table-column>
                <el-table-column label="操作" width="150" align="center">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" plain
                                   :disabled="scope.row.entered === true || scope.row.application_unfinished === true"
                                   @click="apply(scope.row)" :loading="scope.row.id === requestingId && applyRequesting"
                        >
                            {{ scope.row.entered === true ? '已入队' :
                            scope.row.application_unfinished === true ? '申请处理中' : '申请加入' }}
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import {handlePlayers} from '../../../../utils/data-handler';
    import _ from 'lodash';

    export default {
        name: '',
        props: {
            entered: {
                type: Array,
                default: () => []
            },
            unfinished: {
                type: Array,
                default: () => []
            }
        },
        data () {
            return {
                requestingId: null,
                keyword: null,
                candidates: [],
                requesting: false,
                applyRequesting: false
            };
        },
        methods: {
            search () {
                const keyword = this.keyword;
                this.requesting = true;
                if (keyword === null || keyword === '') {
                    this.candidates = [];
                    this.requesting = false;
                    return;
                }
                this.$normalRequest('player/searchRegistrableByFuzzySchoolName', {
                    school_name: this.keyword
                }, false, false, this, 'requesting').then(data => {
                    const candidates = handlePlayers(data);
                    const enteredPlayerIds = _.map(this.entered, 'id');
                    const unfinishedPlayerIds = _.map(this.unfinished, 'player.id');
                    for (const index in candidates) {
                        const current = candidates[index];
                        if (enteredPlayerIds.indexOf(current.id) > -1) {
                            current['entered'] = true;
                        }
                        if (unfinishedPlayerIds.indexOf(current.id) > -1) {
                            current['application_unfinished'] = true;
                        }
                    }
                    this.candidates = candidates;
                }).catch(_ => {
                });
            },
            apply (player) {
                const playerId = player.id;
                this.requestingId = playerId;
                this.$normalConfirm('确认加入该参赛队？', '申请成功后请等待学生队长审核').then(_ => {
                    this.$normalRequest('player/applyContestant', {
                        player_id: playerId
                    }, '申请提交成功', true, this, 'applyRequesting').then(_ => {
                        this.$emit('need-reload', () => {
                            this.search();
                        });
                    }).catch(_ => {
                    });
                }).catch(_ => {
                });
            }
        }
    };
</script>
